import { render, staticRenderFns } from "./DeudaClientes.vue?vue&type=template&id=137a37f6&"
import script from "./DeudaClientes.vue?vue&type=script&lang=js&"
export * from "./DeudaClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports